import React from "react";
import LongArrow from "../../assets/images/icons/long_arrow.svg";
const LongArrowIcon = () => {
    return React.createElement(LongArrow, null);
};
export default LongArrowIcon;
//# sourceMappingURL=LongArrowIcon.js.map